import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d888fe08"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"text-align":"center"} }
const _hoisted_2 = { class: "p-text-center" }
const _hoisted_3 = { class: "p-float-label" }
const _hoisted_4 = { class: "p-mt-3" }
const _hoisted_5 = { class: "p-float-label" }
const _hoisted_6 = { class: "p-mt-3" }
const _hoisted_7 = { class: "p-float-label" }
const _hoisted_8 = { class: "p-mt-3" }
const _hoisted_9 = { class: "p-float-label" }
const _hoisted_10 = { class: "p-mt-3" }
const _hoisted_11 = { class: "p-float-label" }
const _hoisted_12 = { class: "p-mt-3" }
const _hoisted_13 = { class: "p-no-float-label" }
const _hoisted_14 = {
  key: 0,
  class: "tags"
}
const _hoisted_15 = { class: "list-item-text" }
const _hoisted_16 = { class: "call-to-action mobile-bottom-nav" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-angle-left" }, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-angle-right" }, null, -1))

import { ref, onMounted, computed } from 'vue';
    import { useI18n } from "vue-i18n";
    import { BriefcaseIcon } from "@heroicons/vue/outline";
    import useVuelidate from '@vuelidate/core';
    import InputNumber from 'primevue/inputnumber';
    import Timeline from "@/registration/tech/wizard/Timeline.vue";
    import { WillingnessToChange } from "@/models/WillingnessToChange";
    import { ChangeMotivation } from "@/models/ChangeMotivation";
    import { createChangeMotivationService } from "@/services/changeMotivationService";

    type FulltimeOption = {
        name: string;
        value: number;
        innerValue: boolean | null;
    };
    type ChangeOption = {
        name: string;
        innerValue: WillingnessToChange;
    };
    
export default /*#__PURE__*/_defineComponent({
  __name: 'StepThree',
  props: ["candidate", "step", "isDirectSignUp"],
  emits: ['submit', 'previous'],
  setup(__props, { emit: __emit }) {

    const props = __props;
    const emit = __emit;
    const step = ref(props.step);
    const user = ref(props.candidate);
    const { t } = useI18n();
    const fulltimeOptions = ref<FulltimeOption[]>();
    fulltimeOptions.value = [
        { value: 1, innerValue: true, name: t("fulltime") },
        { value: 2, innerValue: false, name: t("parttime.greater") },
        { value: 3, innerValue: null, name: t("parttime.lesser") },
    ] as FulltimeOption[];
    const fullTimeOptionSelection = computed({
        get: () => {
            const selected = fulltimeOptions.value?.find(
                (option) => option.innerValue == user.value.fullTime
            );
            return selected?.value;
        },
        set: (value) => {
            if (value) {
                const selected = fulltimeOptions.value?.find(
                    (option) => option.value == value
                );
                user.value.fullTime = selected?.innerValue;
            }
        },
    });

    const handleMotivationRemoval = async (option: ChangeMotivation) => {
        const index = user.value.changeMotivations.indexOf(option);
        if (index !== -1) user.value.changeMotivations.splice(index, 1);
    };

    const changeOptionSelection = computed({
        get: () => {
            const selected = changeOptions.value?.find(
                (option) => option.value == user.value.willingnessToChange
            );
            return selected?.value;
        },
        set: (value) => {
            if (value) {
                const selected = changeOptions.value?.find(
                    (option) => option.value == value
                );
                user.value.willingnessToChange = selected?.value;
            }
        },
    });

    const noticePeriodOptions = [1, 8, 7, 6, 5, 247, 244, 246, 4, 2, 245, 3, 9, 10]
        .map(x => { return { id: x, name: t('registration.tech.noticeperiod.' + x) } });

    const changeOptions = ref<ChangeOption[]>();
    changeOptions.value = [
        {
            value: WillingnessToChange.VeryHigh,
            name: t("profilepage.willingnesstochange.4"),
        },
        {
            value: WillingnessToChange.RatherHigh,
            name: t("profilepage.willingnesstochange.3"),
        },
        {
            value: WillingnessToChange.RatherLow,
            name: t("profilepage.willingnesstochange.2"),
        },
    ];

    const motivationOptions = ref<ChangeMotivation[]>();
    const fetchChangeMotivations = async () => {
        const service = await createChangeMotivationService();
        const response = (await service.getByBrandId(1)).data;
        motivationOptions.value = response.map(x => ({ id: x.id, name: t("job.preferences.changemotivations." + x.id) }))
    }

    const rules = computed(() => {
        return {
            fullTime: {},
            desiredSalary: {},
            desiredSalaryBonus: {},
            noticePeriodId: {},
            changeMotivations: {},
        }
    });
    const v$ = useVuelidate(rules, user);
    const validate = () => {
        v$.value.$touch();
        return v$.value.$error;
    }

    const submit = async () => {
        if (validate())
            return;

        emit("submit");
    }
    const prev = async () => {
        emit("previous");
    }

    onMounted(async () => {
        await fetchChangeMotivations();
    });


return (_ctx: any,_cache: any) => {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Button = _resolveComponent("Button")!
  const _component_MultiSelect = _resolveComponent("MultiSelect")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(BriefcaseIcon), { style: {"width":"60px"} }),
      _createElementVNode("h1", _hoisted_2, _toDisplayString(_unref(t)("registration.tech.headline2")), 1),
      _createVNode(Timeline, { step: step.value }, null, 8, ["step"])
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("span", _hoisted_3, [
        _createVNode(_component_Dropdown, {
          modelValue: fullTimeOptionSelection.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((fullTimeOptionSelection).value = $event)),
          options: fulltimeOptions.value,
          optionLabel: "name",
          optionValue: "value",
          "data-cy": "wizard-fullTime"
        }, null, 8, ["modelValue", "options"]),
        _createElementVNode("label", null, _toDisplayString(_unref(t)("registration.tech.fulltime")), 1)
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).fullTime.$errors, (error, index) => {
        return (_openBlock(), _createElementBlock("small", {
          class: "p-error",
          key: index
        }, _toDisplayString(_unref(t)(error.$message)), 1))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("span", _hoisted_5, [
        _createVNode(_unref(InputNumber), {
          modelValue: _unref(v$).desiredSalary.$model,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(v$).desiredSalary.$model) = $event)),
          mode: "currency",
          currency: "EUR",
          locale: "de-DE",
          class: _normalizeClass({'p-invalid':_unref(v$).desiredSalary.$error}),
          "data-cy": "wizard-salary"
        }, null, 8, ["modelValue", "class"]),
        _createElementVNode("label", null, _toDisplayString(_unref(t)("registration.tech.salary")), 1)
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).desiredSalary.$errors, (error, index) => {
        return (_openBlock(), _createElementBlock("small", {
          class: "p-error",
          key: index
        }, _toDisplayString(_unref(t)(error.$message)), 1))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("span", _hoisted_7, [
        _createVNode(_unref(InputNumber), {
          modelValue: _unref(v$).desiredSalaryBonus.$model,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(v$).desiredSalaryBonus.$model) = $event)),
          mode: "currency",
          currency: "EUR",
          locale: "de-DE",
          class: _normalizeClass({'p-invalid':_unref(v$).desiredSalaryBonus.$error}),
          "data-cy": "wizard-bonus"
        }, null, 8, ["modelValue", "class"]),
        _createElementVNode("label", null, _toDisplayString(_unref(t)("registration.tech.bonus")), 1)
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).desiredSalaryBonus.$errors, (error, index) => {
        return (_openBlock(), _createElementBlock("small", {
          class: "p-error",
          key: index
        }, _toDisplayString(_unref(t)(error.$message)), 1))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("span", _hoisted_9, [
        _createVNode(_component_Dropdown, {
          modelValue: _unref(v$).noticePeriodId.$model,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(v$).noticePeriodId.$model) = $event)),
          options: _unref(noticePeriodOptions),
          optionLabel: "name",
          optionValue: "id",
          "data-cy": "wizard-noticeperiod"
        }, null, 8, ["modelValue", "options"]),
        _createElementVNode("label", null, _toDisplayString(_unref(t)("registration.tech.noticeperiod")), 1)
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).noticePeriodId.$errors, (error, index) => {
        return (_openBlock(), _createElementBlock("small", {
          class: "p-error",
          key: index
        }, _toDisplayString(_unref(t)(error.$message)), 1))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("span", _hoisted_11, [
        _createVNode(_component_Dropdown, {
          options: changeOptions.value,
          modelValue: changeOptionSelection.value,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((changeOptionSelection).value = $event)),
          optionLabel: "name",
          optionValue: "value",
          "data-cy": "job-preferences-dropdown"
        }, null, 8, ["options", "modelValue"]),
        _createElementVNode("label", null, _toDisplayString(_unref(t)("job.preferences.choose.willingnesstochange")), 1)
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("span", _hoisted_13, [
          (user.value.changeMotivations?.length && user.value.changeMotivations.length>0)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_14, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(user.value.changeMotivations, (x) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: x.id
                  }, [
                    _createTextVNode(_toDisplayString(_unref(t)("job.preferences.changemotivations." + x.id)) + " ", 1),
                    _createVNode(_component_Button, {
                      icon: "pi pi-times",
                      class: "p-button-rounded p-button-outlined",
                      onClick: ($event: any) => (handleMotivationRemoval(x))
                    }, null, 8, ["onClick"])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_MultiSelect, {
            modelValue: _unref(v$).changeMotivations.$model,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(v$).changeMotivations.$model) = $event)),
            display: "none",
            class: _normalizeClass({ 'p-invalid': _unref(v$).changeMotivations.$error }),
            options: motivationOptions.value,
            optionLabel: "name",
            "data-cy": "job-preferences-change-motivation"
          }, {
            option: _withCtx((slotProps) => [
              _createElementVNode("div", _hoisted_15, _toDisplayString(slotProps.option.name), 1)
            ]),
            _: 1
          }, 8, ["modelValue", "class", "options"]),
          _createElementVNode("label", null, _toDisplayString(_unref(t)("job.preferences.choose.changemotivation")), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).changeMotivations.$errors, (error, index) => {
            return (_openBlock(), _createElementBlock("small", {
              class: "p-error p-mt-0",
              key: index
            }, _toDisplayString(error.$message), 1))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createVNode(_component_Button, {
        "data-cy": "tech-reg-button-back",
        class: "button-secondary button-back p-pl-3",
        onClick: _cache[6] || (_cache[6] = ($event: any) => (prev()))
      }, {
        default: _withCtx(() => [
          _hoisted_17,
          _createTextVNode(_toDisplayString(_unref(t)("back")), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_Button, {
        "data-cy": "tech-reg-button-next",
        class: "button-primary button-next p-pr-3",
        onClick: _cache[7] || (_cache[7] = ($event: any) => (submit()))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(__props.isDirectSignUp ? _unref(t)("continue") : _unref(t)("submit")) + " ", 1),
          _hoisted_18
        ]),
        _: 1
      })
    ])
  ], 64))
}
}

})